import { useState } from "react";
import { Navbar, Nav, Container, Button } from "react-bootstrap";
import { Menu, X, Phone, Home, Settings } from "lucide-react";
import "../Resources/style.css";

const NavbarNew = () => {
  const [expanded, setExpanded] = useState(false);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
    setExpanded(false);
  };

  return (
    <Navbar
      expand="md"
      expanded={expanded}
      fixed="top"
      className="shadow-sm border-bottom"
      style={{ backgroundColor: "rgba(255,255,255,0.95)", backdropFilter: "blur(10px)" }}
    >
      <Container>
        {/* Logo */}
        <Navbar.Brand href="#" className="d-flex align-items-center">
          <img
            src="https://customer-assets.emergentagent.com/job_biketechpro/artifacts/9yrxeouv_Image%20%2839%29.jpeg"
            alt="YT MotoCenter Logo"
            className="rounded-circle border border-2 border-warning"
            style={{ height: "48px", width: "48px", objectFit: "cover" }}
          />
          <div className="ms-2">
            <h5 className="mb-0 fw-bold text-dark">YT MotoCenter</h5>
            <small className="text-muted">Taller de Motocicletas</small>
          </div>
        </Navbar.Brand>

        {/* Toggle */}
        <Navbar.Toggle
          aria-controls="main-navbar"
          onClick={() => setExpanded(!expanded)}
          className="border-0"
        >
          {expanded ? <X size={24} /> : <Menu size={24} />}
        </Navbar.Toggle>

        {/* Links */}
        <Navbar.Collapse id="main-navbar">
          <Nav className="ms-auto d-flex align-items-center gap-3">
            <Nav.Link
              onClick={() => scrollToSection("hero")}
              className="nav-link-custom d-flex align-items-center fw-medium text-dark"
            >
              <Home size={16} className="me-1" />
              Inicio
            </Nav.Link>
            <Nav.Link
              onClick={() => scrollToSection("services")}
              className="nav-link-custom d-flex align-items-center fw-medium text-dark"
            >
              <Settings size={16} className="me-1" />
              Servicios
            </Nav.Link>
            <Nav.Link
              onClick={() => scrollToSection("contact")}
              className="nav-link-custom d-flex align-items-center fw-medium text-dark"
            >
              <Phone size={16} className="me-1" />
              Contacto
            </Nav.Link>

            <Button
              href="/admin/login"
              className="btn-custom fw-medium text-white px-4 py-2 rounded-pill ms-3"
              style={{
                background: "linear-gradient(to right, #f97316, #ea580c)",
                border: "none",
              }}
            >
              Admin
            </Button>
          </Nav>
        </Navbar.Collapse>

      </Container>
    </Navbar>
  );
};

export default NavbarNew;
